import { differenceInDays } from 'date-fns';
import store from 'lib/store';

export const CHECK_EXPIRED_SUBS_DATE = 'checkExpiredDeviceDate';
export const EXPIRED_SUBS_SCREEN = 'expiredSubsScreen';

// делаем запрос за отмененной подпиской раз в месяц
export const canCheckExpiredSubs = (userEmail: string | null): boolean => {
    if (!userEmail) {
        return false;
    }

    const id = `${userEmail}|${CHECK_EXPIRED_SUBS_DATE}`;
    const lastCheckDate = store.get(id) ?? 0;

    const screenWasShown = store.get(`${userEmail}|${EXPIRED_SUBS_SCREEN}`);

    // если баннер был когда-то показан, то больше не показываем
    if (screenWasShown) {
        return false;
    }

    const now = Date.now();

    if (!lastCheckDate || differenceInDays(now, lastCheckDate) >= 30) {
        store.set(id, now);
        return true;
    }

    return false;
};

// показывем сплеш скрин 4 раза, каждые 5 дней
export const canShowExpiredScreen = (userEmail: string | null): boolean => {
    if (!userEmail) {
        return false;
    }

    const MAX_SHOW_COUNT = 4;
    const id = `${userEmail}|${EXPIRED_SUBS_SCREEN}`;
    const idCount = `${userEmail}|${EXPIRED_SUBS_SCREEN}_count`;

    const showCount = store.get(idCount) ?? 0;

    if (showCount >= MAX_SHOW_COUNT) {
        return false;
    }

    const lastShowDate = store.get(id);
    const now = Date.now();

    if (!showCount || !lastShowDate || differenceInDays(now, lastShowDate) >= 5) {
        store.set(id, now);
        store.set(idCount, showCount + 1);

        return true;
    }

    return false;
};
